import { AloftPrice } from '@aloft/toolkit-shared';

import { Td } from '../../../summary/components/Td.js';
import { Tr } from '../../../summary/components/Tr.js';
import { Typography } from '../../../summary/components/Typography.js';
import { COST_APPROACH_COLUMN_WIDTHS } from '../constants.js';
import { sumPercentWidths } from '../utils/sumPercentWidths.js';
import { CostApproachSummaryRollupRow } from './CostApproachSummaryRollupRow.js';

export const CostApproachSummaryDepreciatedCostRow = ({
  cost,
}: {
  cost: AloftPrice | undefined;
}) => (
  <>
    <CostApproachSummaryRollupRow
      label="Depreciated Cost of Improvements"
      value={cost?.toString(true) ?? ''}
    />
    <Tr>
      <Td width={COST_APPROACH_COLUMN_WIDTHS[0]} isFirstColumn={true}>
        <Typography variant="body1">“As-is” Value of Site Improvements</Typography>
      </Td>
      <Td width={sumPercentWidths(...COST_APPROACH_COLUMN_WIDTHS.slice(1, 4))} colSpan={7}>
        <Typography variant="body1" textAlign="right">
          Included in Site Value
        </Typography>
      </Td>
    </Tr>
  </>
);
